/**
 * @file 头部导航
 * @author chenyuyang
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import {recordProxy, clearLocalStorage} from '../../util';
import logo from '../../asset/img/logo.png';
import grayLogo from '../../asset/img/gray-logo.png';
import needLoginList from '../../constants/needLoginList';
import {Menu} from 'antd';
const {SubMenu} = Menu;

import './index.less';
const dataSource = [
    {
        key: '/',
        path: '/home',
        content: '首页'
    },
    {
        key: '/attest',
        path: '/attest',
        content: '企业号码认证'
    },
    {
        key: '/call_auth',
        path: '/call_auth',
        content: '来电名片认证'
    },
    {
        key: '/mark',
        path: '/mark',
        content: '12321号码投诉'
    },
    {
        key: '/more',
        path: '/more',
        content: '更多号码服务',
        children: [{
            key: '/appeal',
            path: '/appeal',
            content: '号码标记申诉'
        }, {
            key: '/occupy',
            path: '/occupy',
            content: '号码占用申诉'
        }, {
            key: '/verify_msg',
            path: '/verify_msg',
            content: '认证信息修改'
        }, {
            key: '/feedback',
            path: '/feedback?pagef=topbanner',
            content: '号码质量反馈',
        }]
    },
    {
        key: '/help',
        path: '/help',
        content: '帮助中心'
    }
];

const menuStyle = {
    background: 'transparent',
    color: '#fff'
};
const defaultUserMenuStyle = {
    position: 'absolute',
    right: '30px',
    height: '100%',
    lineHeight: '60px',
    fontSize: '14px',
    color: '#fff',
    background: 'transparent'
};
const newRoutePath = [
    '/',
    '/home',
    '/attest',
    '/attests',
    '/attest/simple',
    '/attests',
    '/appeal',
    '/occupy',
    '/mark',
    '/mark_msg',
    '/feedback',
    '/verify_msg',
    '/phoneSearch',
    '/call_auth'
];
const whiteBgRouters = [
    '/phoneSearch'
];
class Header extends Component<any, any> {
    static propTypes = {
        userInfo: PropTypes.object,
        location: PropTypes.object,
        history: PropTypes.object
    };
    constructor(props: any) {
        super(props);
        const currentPathname = props.location.pathname;
        this.state = {
            isShowPanel: false,
            transparentBg: true,
            isClosed: false,
            keepBg: false,
            current: currentPathname === '/' ? '/home'
                : currentPathname.indexOf('/attest/simple') > -1 || currentPathname === '/attests'
                    ? '/attest' : currentPathname,
            isWhiteBg: false
        };
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const currentPathname = nextProps.location.pathname;
        return {
            ...prevState,
            current: currentPathname === '/' ? '/home'
                : currentPathname.indexOf('/attest/simple') > -1 || currentPathname === '/attests'
                    ? '/attest' : currentPathname,
            keepBg: !newRoutePath.includes(currentPathname),
            isWhiteBg: whiteBgRouters.includes(currentPathname)
        };
    }

    componentDidMount() {
        // document.body.addEventListener('scroll', this.scrollFn);
        document.body.onscroll = this.scrollFn;
    }
    login = () => {
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const ele = document.createElement('a');
        ele.href = `https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
            encodeURIComponent(window.location.href)
        }`;
        ele.click();
    };
    handleClick =(e: any) => {
        let url = e.key === '/' ? '/home' : e.key;
        url = url.split('?')[0];
        recordProxy('newNav', 'click', url.replace('/', ''));
        const {userInfo = {}} = this.props;
        if (needLoginList.includes(e.key) && userInfo.code !== 200) {
            this.login();
        } else {
            this.setState({
                current: e.key === '/' ? '/home' : e.key
            }, () => {
                if (e.key === '/mark') {
                    this.props.history.push(e.key + '?pagef=topbanner');
                } else {
                    this.props.history.push(e.key);
                }
            });
        }
    };

    scrollFn = () => {
        /* eslint-disable-next-line */
        let scrollTop = document.documentElement.scrollTop;
        if (scrollTop > 10) {
            this.setState({
                transparentBg: false
            });
        } else {
            this.setState({
                transparentBg: true
            });
        }
    };
    onLogout = () => {
        // window.localStorage.clear();
        clearLocalStorage();
        window.location.href = `/api/v1/user/logout?string=${encodeURIComponent(window.location.origin)}`;
    };

    onLogoClick = () => {
        this.props.history.push('/');
        recordProxy('newNav', 'click', 'homeLogo');
    };
    handleLoginClick = () => {
        recordProxy('newNav', 'click', 'login');
    };
    render() {
        const {transparentBg, current, keepBg, isWhiteBg} = this.state;
        const {userInfo = {}} = this.props;
        const isDev = window.location.href.indexOf('haoma.baidu.com') > -1 ? false : true;
        const navStyle = {
            ...menuStyle,
            color: isWhiteBg ? '#666' : '#fff'
        };
        const userMenuStyle = {
            ...defaultUserMenuStyle,
            color: isWhiteBg ? '#666' : '#fff'
        };
        return (
            <div className={'comp-header '
                + (transparentBg && !keepBg? 'transparent' : 'bg') + (isWhiteBg ? ' white-bg' : '')}>
                <div className="header-content-wrapper">
                    <div className="brand" onClick={this.onLogoClick}>
                        <img src={isWhiteBg ? grayLogo : logo} alt=""/>
                    </div>
                    <Menu
                        onClick={this.handleClick}
                        selectedKeys={[current]}
                        mode="horizontal"
                        // triggerSubMenuAction="click"
                        style={navStyle}
                        theme={isWhiteBg ? 'light' : 'dark'}
                    >
                        {dataSource.map(item => {
                            if (item.children) {
                                return (<SubMenu key={item.path}
                                    popupClassName={'common-header '
                                        + (transparentBg ? 'transparent' : 'bg') + (isWhiteBg ? ' white-bg' : '')}
                                    title={<span className={isWhiteBg ? 'white-bg-title' : ''}>{item.content}</span>}>
                                    {item.children.map(child => {
                                        return (<Menu.Item key={child.path}>{child.content}</Menu.Item>);
                                    })}
                                </SubMenu>);
                            } else {
                                return (<Menu.Item className={isWhiteBg ? 'white-bg' : ''} key={item.path}>
                                    {item.content}</Menu.Item>);
                            }
                        })}
                    </Menu>
                    {userInfo.code === 200 ? <Menu
                        onClick={this.handleClick}
                        selectedKeys={[current]}
                        mode="horizontal"
                        // triggerSubMenuAction="click"
                        style={userMenuStyle}
                        theme={isWhiteBg ? 'light' : 'dark'}
                    ><SubMenu title={<span className={isWhiteBg ? 'white-bg-title' : ''}>{userInfo?.data.name}</span>}>
                            <Menu.Item key={'/user_center/my_attest'}>个人中心</Menu.Item>
                            <Menu.Item>
                                <a onClick={this.onLogout}>退出账户</a>
                            </Menu.Item>
                        </SubMenu></Menu>
                        : <a
                            className={'login ' + (isWhiteBg ? 'white-bg' : '')}
                            href={`https://passport${isDev ? '.qatest' : ''}.baidu.com/v2/?login&u=${
                                encodeURIComponent(window.location.href)
                            }`}
                            onClick={this.handleLoginClick}
                        >登录</a>}
                </div>
            </div>
        );
    }
}
export default withRouter(Header);
